import * as React from "react";
import * as classNames from "classnames";
import { Tooltip, TooltipHeader, TooltipBody } from "ComponentsUI/Tooltip";
import { RatingPlace, RatingSpec } from "ComponentsUI/RatingsViews";
import withStyles from "react-jss";
import TariffTableContainerInCatalog from "Containers/TariffTableContainerInCatalog";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { getDeclination } from "Utils/text";
import LazyImage from "ComponentsUI/Image";

const styles = (theme) => {
	return {
		root: {
			border: `1px solid ${theme.palette.colors.purplishBlue}`,
			borderRadius: "10px",
			marginBottom: "40px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			backgroundColor: theme.palette.colors.white,
			width: "101%",
			"&:last-child": {
				marginBottom: "30px",
			},
		},
		ratingWrapper: {
			borderRadius: "10px",
			display: "flex",
			alignItems: "center",
			padding: "20px 0",
			width: "100%",
			marginBottom: "10px",
		},
		isTarriffsBorder: {},
		isMinHeight: {
			padding: "5px 0",
			marginBottom: "0",
		},
		rating: {
			width: "80px",
			marginRight: "20px",
			textAlign: "right",
			flexShrink: 0,
			marginLeft: "20px",
			height: "65px",
		},
		reviewText: {
			color: theme.palette.colors.oneMoreGrey,
		},
		logoWrapper: {
			width: "170px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			flexShrink: 0,
			margin: "0 10px",
			"& $logoText": {
				display: "none",
			},
		},
		logo: {
			width: "auto",
			maxHeight: "40px",
			marginTop: "5px",
		},
		providerName: {
			fontFamily: theme.fonts.medium,
			margin: "12px 0 0",
			fontSize: "16px",
			lineHeight: 1.13,
			color: theme.palette.colors.darkSlateBlue,
			textAlign: "center",
		},
		logoText: {
			fontFamily: theme.fonts.medium,
			fontSize: "17px",
			minWidth: "114px",
			lineHeight: "1.29",
			color: theme.palette.colors.oneMoreGrey,
			marginTop: "auto",
			textAlign: "center",
			marginBottom: "0px",
		},
		servicesListWrapper: {
			margin: "0 auto",
		},
		servicesList: {
			display: "flex",
			justifyContent: "center",
		},
		listItem: {
			width: "40px",
			marginRight: "10px",
			"&:last-child": {
				marginRight: 0,
			},
		},
		menu: {
			margin: "0 auto",
			flexShrink: 0,
			textAlign: "center",
			width: "300px",
		},

		allTariffsBtn: {
			fontFamily: theme.fonts.medium,
			fontSize: "14px",
			letterSpacing: "2px",
			color: theme.palette.colors.oneMoreGrey,
			display: "flex",
			width: "100%",
			height: "70px",
			textTransform: "uppercase",
			textAlign: "center",
			justifyContent: "center",
			alignItems: "center",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			rating: {
				marginRight: 0,
			},
			logoWrapper: {
				width: "130px",
			},
			logo: {
				maxHeight: "35px",
			},
			menu: {},
			servicesList: {
				width: "auto",
			},
			listItem: {
				width: "30px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			ratingWrapper: {
				padding: "10px 0",
			},
			isMinHeight: {
				padding: "5px 0",
				marginBottom: "0",
			},
			rating: {
				width: "80px",
				margin: 0,
				height: "45px",
			},
			logoWrapper: {
				width: "100px",
			},
			logo: {
				maxHeight: "25px",
				marginTop: 0,
			},
			logoText: {
				fontSize: "15px",
				lineHeight: "0.8",
			},
			servicesList: {
				width: "auto",
			},
			servicesListWrapper: {},

			listItem: {
				width: "30px",
			},
			menu: {},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			ratingWrapper: {
				height: "auto",
				padding: "15px 0",
			},
			isMinHeight: {
				padding: "5px 0",
				marginBottom: "0",
			},
			isTarriffsBorder: {
				borderBottom: `1px solid ${theme.palette.colors.purplishBlue}`,
			},
			servicesList: {
				display: "none",
			},
			rating: {
				marginRight: 0,
				marginLeft: "10px",
				height: "52px",
				width: "60px",
			},
			logoWrapper: {
				margin: "0 auto",
				width: "auto",
			},
			providerName: {
				fontSize: "14px",
				overflowWrap: "break-word",
				width: "110px",
			},
			logo: {
				height: "25px",
				marginTop: 0,
			},
			logoText: {
				lineHeight: "0.8",
				fontSize: "12px",
				minWidth: "90px",
			},
			infoList: {
				margin: "0 auto",
			},
			listItem: {
				width: "40px",
				marginRight: "0",
			},
			menu: {
				display: "none",
				marginLeft: 0,
			},
			servicesListWrapper: {},
			allTariffsBtn: {
				height: "40px",
			},
		},
	};
};

class Component extends React.Component {
	static defaultProps = {
		classes: {},
		showPopUp: false,
		data: {
			rating: {},
			linkCard: "/",
			specifications: [],
		},
	};

	generateAllTariffButton() {
		let { data } = this.props;
		let classes = this.props.classes;
		let text = this.props.text;
		let tariffs = this.props.data?.tariffs;
		let countTariff = data?.info?.cnt_tariffs || 0;
		let buttonAllTariffs = (
			<p>
				{text.ALL_RATES}
				{!!countTariff && " (" + countTariff + ")"}
			</p>
		);
		if (!tariffs?.length) {
			return null;
		} else {
			return React.cloneElement(this.props.linkComponent, {
				onClick: this.preventPropagation,
				to: data.linkTariffs,
				className: classes.allTariffsBtn,
				children: buttonAllTariffs,
			});
		}
	}

	getReviewsWord(count) {
		const { text } = this.props;

		return getDeclination(
			count,
			text.REVIEWS_SUFFIX.ONE,
			text.REVIEWS_SUFFIX.TWO,
			text.REVIEWS_SUFFIX.MANY
		);
	}

	render() {
		let { data } = this.props;
		let classes = this.props.classes;
		let text = this.props.text;
		let tariffs = this.props.data?.tariffs;
		let exclusiveTariffs = tariffs
			?.filter((item) => {
				if (item.provider.id === data.id && !!item.exclusives && !item.districts) return true;
			})
			.slice(0, 2);
		let districtsTariffs = tariffs
			?.filter((item) => {
				if (item.provider.id === data.id && !!item.exclusives && !!item.districts) return true;
			})
			.slice(0, 2);
		let homeTariffs = tariffs
			?.filter((item) => {
				if (item.provider.id === data.id && item.internet?.speed_in > 0 && !item.exclusives)
					return true;
			})
			.slice(0, 1);

		// homeTariffs?.shift();
		let newTariffs;
		if (!!exclusiveTariffs?.length) {
			newTariffs = exclusiveTariffs;
		} else if (!!districtsTariffs?.length) {
			newTariffs = districtsTariffs;
		} else if (!!tariffs?.length) {
			newTariffs = homeTariffs;
		}

		let toReviewUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: this.props.match.params.regionUrl,
			providerName: this.props.data.url_name,
		});

		return (
			<div className={classes.root}>
				<div
					className={classNames(classes.ratingWrapper, {
						[classes.isTarriffsBorder]: !!newTariffs?.length,
						[classes.isMinHeight]: !newTariffs?.length,
					})}
				>
					<div className={classes.rating}>
						<RatingPlace
							text={text}
							rating={(Math.round(data.rating.rating) * 0.1).toFixed(1)}
							position={data.position}
						/>
					</div>
					<div className={classes.logoWrapper}>
						{React.cloneElement(this.props.linkComponent, {
							to: data.linkCard,
							datatest: "raiting_provider_button",
							"aria-label": `Лого компании ${data.name}`,

							children: (
								<LazyImage
									src={
										!!this.props.webpTransformer ? this.props.webpTransformer(data.logo) : data.logo
									}
									className={classes.logo}
									alt={this.props.data.name}
								/>
							),
						})}
						{React.cloneElement(this.props.linkComponent, {
							to: data.linkCard,
							className: classes.providerName,
							children: this.props.data.name,
						})}
						<div className={classes.logoText}>
							{data.rating.review_all
								? `${data.rating.review_all} ${this.getReviewsWord(data.rating.review_all)}`
								: text.REVIEWS_EMPTY_STUB_HEADER}
						</div>
					</div>
					<div className={classes.servicesListWrapper}>
						<div className={classes.logoText}>
							<Link className={classes.reviewText} to={toReviewUrl}>
								{data.rating.review_all
									? `${data.rating.review_all} ${this.getReviewsWord(data.rating.review_all)}`
									: text.REVIEWS_EMPTY_STUB_HEADER}
							</Link>
						</div>
					</div>
					<div className={classes.menu}>{data.linkConnect}</div>
				</div>
				{!!newTariffs?.length && (
					<TariffTableContainerInCatalog
						showNames={true}
						providers={[this.props.data]}
						tariffs={newTariffs}
						compareIsHide={true}
						hideProviderLogo={true}
						isRating={true}
						pageName={this.props.pageName}
					/>
				)}
				{!!newTariffs?.length && this.generateAllTariffButton()}
			</div>
		);
	}

	renderSpec() {
		let classes = this.props.classes;
		return this.props.data.specifications
			? this.props.data.specifications.map((spec, key) => {
					let textTooltip = <div dangerouslySetInnerHTML={{ __html: spec.description }}></div>;
					return (
						<Tooltip
							key={key}
							position={`top`}
							header={<TooltipHeader text={spec.name} />}
							body={<TooltipBody> {textTooltip} </TooltipBody>}
						>
							<div key={key} className={classes.listItem}>
								<RatingSpec
									logo={spec.image}
									text={`${!!spec.value ? spec.value.toFixed(1) : "-"}`}
								/>
							</div>
						</Tooltip>
					);
				})
			: null;
	}
}

export default withRouter(withStyles(styles)(Component));
